<form>
  <div class="row keyword-filter-row expanded">
    <div class="col-12">
      <div class="row keyword-filter-row-primary">
        <div class="col-12 filter-input">
          <div class="row">
            <div class="col-11">
              <div class="ui-inputgroup ey-float-label row">
                <input type="text" name="searchStudies" class="form-control search-box ey-field" appLabelFloat [(ngModel)]="searchText" />
                <label></label>
              </div>
            </div>
            <div class="col-1 align-self-center">
              <span class="ui-inputgroup-addon search-icon"
                ><a (click)="onSearchClick()"><i class="material-icons">search</i></a></span
              >
            </div>
          </div>
        </div>
        <!-- <div id="expand-icon-container" class="col-2 align-self-center">
          <a (click)="onClickExpand()" class="filter-list-expand">
            <span><i id="expand-icon" class="material-icons">filter_list</i></span>
          </a>
        </div> -->
      </div>
      <div class="row keyword-filter-row-secondary">
        <p-table
          [value]="filterRows"
          sortField="count"
          sortOrder="-1"
          styleClass="extracted-keyword-table"
          [ngStyle]="{ padding: '0' }"
          [paginator]="true"
          [lazy]="true"
          (onLazyLoad)="paginate($event)"
          [rows]="defaultPageSize"
          [scrollable]="true"
          scrollHeight="calc(100vh - 420px)"
          [totalRecords]="keywordExtractionService?.extractedKeywordsFilteredCount"
          [loading]="keywordsLoading"
          #extractedKeywordsTable
        >
          <ng-template pTemplate="header">
            <tr>
              <th [pSortableColumn]="'keyword'">
                Keyword
                <p-sortIcon [field]="'keyword'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'count'">
                Occurrences
                <p-sortIcon [field]="'count'"></p-sortIcon>
              </th>
              <th class="text-center">Include Function</th>
              <th class="text-center">Include Product</th>
              <th class="text-center">Exclude</th>
              <th></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-keyword>
            <tr>
              <td>{{ keyword.keyword }}</td>
              <td>{{ keyword.count }}</td>
              <td class="text-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    id="{{ keyword.keyword }}_0"
                    type="radio"
                    [value]="keywordType.IncludeFunction"
                    [name]="keyword.keyword + '_0'"
                    class="custom-control-input"
                    [(ngModel)]="keyword.keywordTypeId"
                    (ngModelChange)="selectKeyword(keyword, keywordType.IncludeFunction)"
                    [disabled]="readOnly"
                  />
                  <label class="custom-control-label form-check-label" for="{{ keyword.keyword }}_0"></label>
                </div>
              </td>
              <td class="text-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    id="{{ keyword.keyword }}_1"
                    type="radio"
                    [value]="keywordType.IncludeProduct"
                    [name]="keyword.keyword + '_1'"
                    class="custom-control-input"
                    [(ngModel)]="keyword.keywordTypeId"
                    (ngModelChange)="selectKeyword(keyword, keywordType.IncludeProduct)"
                    [disabled]="readOnly"
                  />
                  <label class="custom-control-label form-check-label" for="{{ keyword.keyword }}_1"></label>
                </div>
              </td>
              <td class="text-center">
                <div class="custom-control custom-radio custom-control-inline">
                  <input
                    id="{{ keyword.keyword }}_2"
                    type="radio"
                    [value]="keywordType.Exclude"
                    [name]="keyword.keyword + '_2'"
                    class="custom-control-input"
                    [(ngModel)]="keyword.keywordTypeId"
                    (ngModelChange)="selectKeyword(keyword, keywordType.Exclude)"
                    [disabled]="readOnly"
                  />
                  <label class="custom-control-label form-check-label" for="{{ keyword.keyword }}_2"></label>
                </div>
              </td>
              <td class="text-center">
                <div class="clear-button" (click)="clearSelection(keyword)"><span *ngIf="keyword.keywordTypeId">Clear</span></div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="paginatorright">
            <span *ngIf="keywordExtractionService?.extractedKeywordsFilteredCount"
              >{{ keywordExtractionService.extractedKeywordsFilteredCount | number }} Records</span
            >
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</form>
